import { Injectable } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { selectConsentGrantSecured } from '@store/checkout/checkout.selectors';
import { Store } from '@ngrx/store';
import { Observable, combineLatest, map } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ResponsiveService {
    secured$: Observable<boolean | undefined> = this.store.select(selectConsentGrantSecured);
    bpObs$ = this.breakpointObserver.observe(['(min-width: 1000px)'])

    responsiveLarge$: Observable<boolean> = combineLatest([this.bpObs$, this.secured$, this.route.events])
    .pipe(map(([state, secured]) => {       
        if (state.matches) {
            return (
                (window.location.href || '').endsWith('/start') ||
                (window.location.href || '').endsWith('/orderReview')
            ) && secured === undefined;
        } else {
            return false;
        }
    }));
    
    constructor(public store: Store, public breakpointObserver: BreakpointObserver, private route: Router) {
    }
}
